import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import {ICellRendererParams, IHeaderParams} from 'ag-grid-community/main';

@Component({
  selector: 'mu-group-header-v2',
  templateUrl: './mu-group-header-v2.component.html',
  styleUrls: ['./mu-group-header-v2.component.css']
})
export class MuGroupHeaderComponentV2 implements OnInit,ICellRendererAngularComp {
  private params: ICellRendererParams;
  private planSettings: any;

  constructor() { }

  public get isRollupHeader(){
    return !!this.params.data?.isRollupHeader;

  }
  public get newHireTrainingWeeks(){
    return this.entitySettings?.newHireTrainingWeeks
  }

  public get isRollupCollapsed(){
    if(this.params.context.isRollupCollapsed){
      return this.params.context.isRollupCollapsed();
    }else{
      return false;
    }

  }
  public get entityOid(){
    return this.params.node.allLeafChildren[0].data.entityInfo?.value.oid;
  }
  public get entitySettings(){
    let entities =  this.params.context.entitySettings();
    return entities[this.entityOid];
  }
  public toggleRollupGroup(){
    if(this.params.context.toggleRollupGroup && this.isRollupHeader) {
      this.params.context.toggleRollupGroup();
    }
  }

  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams<any>): boolean {
    return false;
  }


  showNhtpDialog(event) {
    event.preventDefault();
    this.params.context.showNhtpDialog(this.entityOid);
  }

  get showNhtpLink() {
    if (typeof this.params.context.showNhtpLink === 'function') {
      return this.params.context.showNhtpLink();
    }
    return false;
  }
}
